import React from 'react';
import { Alert, Box } from '@mui/material';
import useCadastreTabs from '../../hooks/useCadastreTabs';
import { useDeleteCadastreEntity } from '../../hooks/cadastre/useDeleteCadastreEntity';
import { getInitialForm7License } from '../../constants/lkCadastr/cadastrForm7';
import { getReferencesRequest } from '../../api/referenceApi';
import { flexGap2, fullWidth } from '../../constants/lkCadastr/cadastrStorage';
import { AsyncAutocomplete } from '../AutoCompletes/AsyncAutocomplete';
import CustomInput from '../Inputs';
import CustomCheckbox from '../CustomCheckbox';
import CustomDatePicker from '../CustomDatePicker';
import AddButton from '../Buttons/AddButton';
import DeleteButton from '../Buttons/DeleteButton';
import NavTabs from '../Tabs';
import { Text } from '../Text';
import { LICENSE_WORK_TYPES_URL } from '../../constants/urls';

export default function CadastreForm7License({
  licenses, changeObject, isDemo, is_license_unneeded, changeLicenseUnneeded, changeItemFormByField, objectIndex, deleteForm7License
}) {
  const changeLicense = (field, value, licenseIndex) => changeObject(`license.${licenseIndex}.${field}`, value);

  const { openDeleteModal } = useDeleteCadastreEntity();

  const { tabs, tab, setTab } = useCadastreTabs({ items: licenses, tabName: 'Лицензия' });

  const addNewLicense = () => {
    changeItemFormByField({ field: `form7.reportTechnologies[${objectIndex}].license`, value: [...licenses, getInitialForm7License()] });
  };

  return (
    <Box sx={flexGap2}>
      <Alert severity="info">
        Не требуется лицензия на деятельность по сбору, транспортированию, обработке, утилизации, обезвреживанию, размещению отходов V класса опасности
      </Alert>
      <CustomCheckbox
        disabled={isDemo}
        label="Лицензия не требуется"
        value={is_license_unneeded}
        onChange={changeLicenseUnneeded}
      />
      {!is_license_unneeded && (
        <>
          {!isDemo && <AddButton sx={{ mt: 3 }} variant="outlined" onClick={addNewLicense}>Добавить лицензию</AddButton>}
          <NavTabs tabsComponents={tabs} setTab={setTab} tab={tab} />
          {licenses?.map((license, licenseIndex) => {
            if (tab !== license.randId) return null;

            const onDeleteLicense = async () => {
              if (license?.id) {
                const deletedLicense = await deleteForm7License({ reportLicenseId: license.id });

                if (!deletedLicense) return;
              }

              const cloneArray = licenses.slice();
              cloneArray.splice(licenseIndex, 1);

              changeItemFormByField({
                field: `form7.reportTechnologies[${objectIndex}].license`,
                value: cloneArray,
                type: 'delete',
              });
            };

            return (
              <Box sx={flexGap2}>
                <Box display="flex" alignItems="center" mb={1} gap={2}>
                  <Text>
                    Лицензия №
                    {licenseIndex + 1}
                  </Text>
                  {!isDemo && licenses.length > 1 && (
                    <DeleteButton
                      onClick={() => openDeleteModal(onDeleteLicense, licenseIndex, 'Лицензию')}
                    >
                      Удалить лицензию
                    </DeleteButton>
                  )}
                </Box>
                <Box>
                  <Text className="mute">Номер</Text>
                  <CustomInput
                    validImmediately
                    debounceTime={0}
                    disabled={isDemo}
                    value={license.license_number}
                    onChange={(e, value) => changeLicense('license_number', value, licenseIndex)}
                    sx={{ width: '100%' }}
                  />
                </Box>
                <Box>
                  <Text className="mute">Дата</Text>
                  <CustomDatePicker
                    canBeZero
                    validImmediately
                    disabled={isDemo}
                    value={license.license_issue_date}
                    onChange={(e, value) => changeLicense('license_issue_date', value, licenseIndex)}
                    sx={{ width: '100%' }}
                  />
                </Box>
                <Box>
                  <Text className="mute">Срок действия</Text>
                  <CustomDatePicker
                    canBeZero
                    validImmediately={!license.is_forever}
                    disabled={isDemo || license.is_forever}
                    value={license.license_expiration}
                    onChange={(e, value) => changeLicense('license_expiration', value, licenseIndex)}
                    sx={{ width: '100%' }}
                  />
                </Box>
                <CustomCheckbox
                  disabled={isDemo}
                  value={license.is_forever}
                  label="Бессрочно"
                  onChange={(e, value) => changeLicense('is_forever', value, licenseIndex)}
                />
                <Box>
                  <Text className="mute">Виды работ</Text>
                  <AsyncAutocomplete
                    multiple
                    validImmediately
                    debounceTime={0}
                    disabled={isDemo}
                    request={(params) => getReferencesRequest({
                      url: LICENSE_WORK_TYPES_URL,
                      params,
                    })}
                    sx={fullWidth}
                    value={license.license_work_types_ids}
                    onChange={(e, value) => changeLicense('license_work_types_ids', value, licenseIndex)}
                  />
                </Box>
              </Box>
            );
          })}
        </>
      )}
    </Box>
  );
}
